// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  width: 90%;
  margin: 15px auto;
}

h3 {
  font-family: AppFontMedium, sans-serif;
  margin-top: 15px;
  margin-bottom: 5px;
}

ion-input {
  margin-top: 10px;
  --padding-start: 10px !important;
}

.button-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.button-block ion-button {
  --background: white;
  color: var(--ion-color-secondary);
  width: 45%;
  font-size: 18px;
  font-family: AppFontMedium, sans-serif;
}

ion-icon {
  z-index: 10;
}

span {
  margin: 10px 0px;
}

.email-msg {
  margin: 0px;
  margin-bottom: 0px;
}

ion-item {
  --border-width: 0px !important;
  border: none;
  border-bottom: 1.2px solid var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/app-restore-password-modal/app-restore-password-modal.component.scss"],"names":[],"mappings":"AAAA;EACC,UAAA;EACA,iBAAA;AACD;;AACA;EACC,sCAAA;EACA,gBAAA;EACA,kBAAA;AAED;;AAAA;EACC,gBAAA;EACA,gCAAA;AAGD;;AADA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAID;AAHC;EACC,mBAAA;EACA,iCAAA;EACA,UAAA;EACA,eAAA;EACA,sCAAA;AAKF;;AAFA;EACC,WAAA;AAKD;;AAHA;EACC,gBAAA;AAMD;;AAJA;EACC,WAAA;EACA,kBAAA;AAOD;;AALA;EACC,8BAAA;EACA,YAAA;EACA,mDAAA;AAQD","sourcesContent":[".wrapper {\n\twidth: 90%;\n\tmargin: 15px auto;\n}\nh3 {\n\tfont-family: AppFontMedium, sans-serif;\n\tmargin-top: 15px;\n\tmargin-bottom: 5px;\n}\nion-input {\n\tmargin-top: 10px;\n\t--padding-start: 10px !important;\n}\n.button-block {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-top: 10px;\n\tion-button {\n\t\t--background: white;\n\t\tcolor: var(--ion-color-secondary);\n\t\twidth: 45%;\n\t\tfont-size: 18px;\n\t\tfont-family: AppFontMedium, sans-serif;\n\t}\n}\nion-icon {\n\tz-index: 10;\n}\nspan {\n\tmargin: 10px 0px;\n}\n.email-msg {\n\tmargin: 0px;\n\tmargin-bottom: 0px;\n}\nion-item {\n\t--border-width: 0px !important;\n\tborder: none;\n\tborder-bottom: 1.2px solid var(--ion-color-primary);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
